export async function resolveEventRegistrationUser(actor, targetUid, loadTarget) {
  if (!actor?.uid) throw new Error("Sem utilizador autenticado.");
  const adminTargetUid = String(targetUid || "").trim();
  if (!adminTargetUid) return { user: actor, adminTargetUid: null };
  if (String(actor.role || "").toLowerCase() !== "admin") {
    throw new Error("Apenas um administrador pode inscrever outro utilizador.");
  }
  const target = await loadTarget(adminTargetUid);
  if (!target) throw new Error("Utilizador a inscrever não encontrado.");
  if (!String(target.email || "").trim()) {
    throw new Error("O utilizador precisa de um email para receber a inscrição e o pagamento.");
  }
  return { user: { ...target, uid: adminTargetUid }, adminTargetUid };
}
